import React, { Component } from 'react';
import './HostNewGameOnlineForm.css';
import { ConnectedUserList } from './ConnectedUserList';

export class HostNewGameOnlineForm extends Component {
    static displayName = "Host new online session";

    intervalID;

  constructor(props) {
      super(props);

      this.copyJoinLinkToClipboard = this.copyJoinLinkToClipboard.bind(this);
      
      this.state = { wordsets: [], keepSession: props.match.params.keepSession, loading: true, selectedSet: "", turns: 9, joinGameLink: null, connectedPlayers: [], movingToGame: false, myusername: "", maxplayers: 2 };
  }

  componentDidMount() {
      this.initiateSession();
    }

    componentWillUnmount() {
        this.stopServerPolling();
    }

    stopServerPolling() {
        clearTimeout(this.intervalID);
    }

    updateGameStateSync = () => {
        if (this.state.movingToGame)
            return;

        fetch('game/state')
            .then(r => r.json())
            .then(data => {
                this.setState({ connectedPlayers: data.connectedPlayers, joinGameLink: data.gameSessionId });

                if (this.state.myusername === "")
                    this.setState({ myusername: data.myUsername });

                if (data.gameState != null) {
                    this.setState({ movingToGame: true });
                    window.location = '/online-game-board';
                    return;
                }

                this.intervalID = setTimeout(this.updateGameStateSync.bind(this), 2000);
            });
    }

    renderNewGameForm() {
        return (
            <div className="container">
                <div>
                    <div className="section">
                        <label>
                            Select word set
                        <select value={this.state.selectedSet} onChange={x => this.setState({ selectedSet: x.target.value })}>
                                {this.state.wordsets.map(x => <option key={x.name} value={x.name}>{x.name}</option>)}
                            </select>
                        </label>
                    </div>
                    <div className="section">
                        <label>
                            Select number of turns available (normal game 9, easy game 11)
                        <input value={this.state.turns} type="text" pattern="[0-9]{1,2}" onChange={x => this.setState({ turns: x.target.value })} />
                        </label>
                    </div>
                    <div className="section">
                        <h4>Set username</h4>
                        <input value={this.state.myusername} type="text" onChange={x => this.setState({ myusername: x.target.value })} />
                        <button className={"btn btn-primary"} onClick={async () => { await this.updateUsername() }}>Update username</button>
                    </div>
                    <div className="section">
                        <h4>Set max players</h4>
                        <input value={this.state.maxplayers} type="text" onChange={x => this.setState({ maxplayers: x.target.value })} />
                        <button className={"btn btn-primary"} onClick={async () => { await this.updateMaxPlayers() }}>Update max player count</button>
                    </div>
                </div>
                <div>
                    <div className="section">
                        <h4>Join game link (copy and email/message to your friend)</h4>
                        <h4>New players only</h4>
                        <label className="joinGameLink">{this.getJoinLink()}</label>
                        <h4>Or invite them by entering following code</h4>
                        <label>Via "Join online game" selection on this website</label>
                        <label className="joinGameLink">{this.getShortCode()}</label>
                    </div>
                    <div className="section">
                        <ConnectedUserList users={this.state.connectedPlayers} />
                    </div>
                </div>
                <div>
                    <button className={"btn btn-primary largeButton"} onClick={async () => { await this.startGame() }}>Start game</button>
                </div>
            </div>);
    }

    getShortCode() {
        if (this.state.joinGameLink == null || this.state.joinGameLink == "")
            return "";
        if (this.state.joinGameLink.length < 8)
            return "";
        return this.state.joinGameLink.substring(0, 8);
    }

    copyJoinLinkToClipboard() {

    }

    getJoinLink() {
        return 'http://' + window.location.host + '/join-game-online/' + this.state.joinGameLink;
    }

    async updateUsername() {
        const response = await fetch('session/username', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: '"' + this.state.myusername + '"'
        });
    }

    async updateMaxPlayers() {
        const response = await fetch('session/max-players', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: this.state.maxplayers
        });
    }

    async startGame() {
        const response = await fetch('game/start', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                wordSetName: this.state.selectedSet,
                countersAvailable: parseInt(this.state.turns)
            })
        });
        const data = await response.json();
        if (!response.ok) {
            alert("Failed starting game: " + this.getErrorMessage(response.statusText, data.errorMessage));
            console.log("Failed starting game: " + response.statusText + ". " + JSON.stringify(response.body));
        }
    }

    getErrorMessage(statusText, errorMessage) {
        if (errorMessage === "")
            return statusText;
        switch (errorMessage) {
            case "StartingGameRequiresAtLeastTwoConnectedUsers": return "Must have at least one more player connected";
            case "NoPlayersInTeamOne": return "No players in team 1";
            case "NoPlayersInTeamTwo": return "No players in team 2";
            default: return errorMessage;
        }
    }

  render() {
    let contents = this.state.loading
      ? <p><em>Loading...</em></p>
      : this.renderNewGameForm();

    return (
      <div>
        {contents}
      </div>
    );
  }

  async initiateSession() {
      const response = await fetch('wordsets');
      const data = await response.json();

      if (this.state.keepSession == null || this.state.keepSession != "keepSession") {
          const sessionInitResponse = await fetch('session/initiate', {
              method: 'POST',
              headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
              }
          });
          const sessionInitData = await sessionInitResponse.json();

          this.setState({ wordsets: data, loading: false, selectedSet: data[0].name, joinGameLink: sessionInitData.gameSessionId, connectedPlayers: sessionInitData.connectedPlayers, myusername: sessionInitData.myUsername });
      } else {
          this.setState({ wordsets: data, loading: false, selectedSet: data[0].name });
      }

      this.intervalID = setTimeout(this.updateGameStateSync.bind(this), 2000);
  }
}
